import { inject, Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private readonly isLoaderVisible$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private readonly loadingRequests: Map<string, number> = new Map<string, number>();
  private readonly ngZone = inject(NgZone);

  get isLoaderVisible(): Observable<boolean> {
    return this.isLoaderVisible$;
  }

  public show(url: string): void {
    const requestCount = this.loadingRequests.get(url) ?? 0;
    this.loadingRequests.set(url, requestCount + 1);
    this.setVisibility(true);
  }

  public hide(url: string): void {
    const requestCount = this.loadingRequests.get(url) ?? 0;

    if (requestCount > 1) {
      this.loadingRequests.set(url, requestCount - 1);
      return;
    }

    if (requestCount === 1) {
      this.loadingRequests.delete(url);
    }

    if (this.loadingRequests.size === 0) {
      this.setVisibility(false);
    }
  }

  public notifyChange(): void {
    this.setVisibility(this.loadingRequests.size > 0);
  }

  private setVisibility(isVisible: boolean): void {
    if (this.isLoaderVisible$.getValue() === isVisible) return;

    this.ngZone.run(() => {
      this.isLoaderVisible$.next(isVisible);
    });
  }
}
